import { render, staticRenderFns } from "./aboutJiazi.vue?vue&type=template&id=97b54860&scoped=true&"
import script from "./aboutJiazi.vue?vue&type=script&lang=js&"
export * from "./aboutJiazi.vue?vue&type=script&lang=js&"
import style0 from "./aboutJiazi.vue?vue&type=style&index=0&id=97b54860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b54860",
  null
  
)

export default component.exports